import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const healthData: AppRouteModule = {
  path: '/',
  name: '',
  component: LAYOUT,
  redirect: '/health-data',
  meta: {
    orderNo: 3,
    icon: 'chart-add|svg',
    title: t('routes.nurse.healthData'),
    hideChildrenInMenu: true,
    hideMenu: false,
  },
  children: [
    {
      path: 'health-data',
      name: 'HealthData',
      component: () => import('/@/views/nurse/health-data/index.vue'),
      meta: {
        icon: 'chart-add|svg',
        title: t('routes.nurse.healthData'),
      },
    },
  ],
};

export default healthData;
